import { render, staticRenderFns } from "./ErrorContent.vue?vue&type=template&id=c8963f3c&scoped=true&"
import script from "./ErrorContent.vue?vue&type=script&lang=js&"
export * from "./ErrorContent.vue?vue&type=script&lang=js&"
import style0 from "./ErrorContent.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ErrorContent.vue?vue&type=style&index=1&id=c8963f3c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8963f3c",
  null
  
)

export default component.exports